import React, {useState} from "react";
import styled from "styled-components";
import {RoutingServiceForm} from "../components/form/RoutingServiceForm";
import theme from "../style/theme";
import {RoutingResponse} from "../types/routing-service/routing-response";
import {ContainedYellowButton} from "../components/button/ContainedYellowButton";
import RoutingExcelDialog from "../containers/routing-service/RoutingExcelDialog";
import {RoutingPayload} from "../types/routing-service/routing-request";
import {RoutingServiceResult} from "../components/board/RoutingServiceResult";

export const RoutingServiceView = () => {
    const [routingResult, setRoutingResult] = useState<
        RoutingResponse | undefined
    >(undefined);
    const [excelDialogOpen, setExcelDialogOpen] = useState(false);
    const [payload, setPayload] = useState<RoutingPayload | undefined | null>(null);

    const handleClickExcelDialogOpen = () => {
        setExcelDialogOpen(true);
    };

    const handleClickExcelDialogClose = () => {
        setExcelDialogOpen(false);
    };

    const handleUploadPayload = (payload: RoutingPayload) => {
        handleClickExcelDialogClose();
        setPayload(payload);
    }

    return (
        <RoutingServiceContainer>
            {excelDialogOpen && (
                <RoutingExcelDialog
                    onUploadPayload={handleUploadPayload}
                    handleClickExcelDialogClose={handleClickExcelDialogClose}
                />
            )}
            <RoutingServiceHeader>
                <RoutingServiceHeaderContainer>
                    <RoutingServiceTitleLabel>
                        동선 최적화
                    </RoutingServiceTitleLabel>
                    <RoutingExcelDialogButtonContainer>
                        <ContainedYellowButton
                            width="130px"
                            height="51px"
                            text="엑셀 등록"
                            onClick={handleClickExcelDialogOpen}
                        />
                    </RoutingExcelDialogButtonContainer>
                </RoutingServiceHeaderContainer>
                <RoutingServiceHeaderTitle2>동선 최적화 결과</RoutingServiceHeaderTitle2>
            </RoutingServiceHeader>
            <RoutingServiceBody>
                <RoutingServiceForm
                    setRoutingResult={setRoutingResult}
                    payload={payload}
                />
                <RoutingServiceResult result={routingResult}/>
                {/*<RoutingServiceResultBoard result={routingResult}/>*/}
            </RoutingServiceBody>
        </RoutingServiceContainer>
    );
};

const RoutingServiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
`;

const RoutingServiceHeaderContainer = styled.div`
  color: #000000;
  height: 73px;
  width: 76%;
  font-size: 24px;
  font-weight: 700;
  line-height: normal;
  padding: 0 0 0 55px;
  margin: 0;
  border-bottom: 1px solid ${theme.palette.primitives.gray200};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const RoutingServiceTitleLabel = styled.div`
  width: fit-content;
`

const RoutingExcelDialogButtonContainer = styled.div`
  width: max-content;
  justify-content: flex-end;
  margin: 0 24px 0 0;
`

const RoutingServiceHeaderTitle2 = styled.div`
  color: ${theme.palette.primitives.gray800};
  width: 24%;
  font-size: 24px;
  font-weight: bold;
  line-height: normal;
  padding: 24px 0 0 32px;
  margin: 0;
  border-bottom: 1px solid ${theme.palette.primitives.gray200};
  border-left: 1px solid ${theme.palette.primitives.gray200};
  box-sizing: border-box;
`;

const RoutingServiceHeader = styled.div`
  display: flex;
  flex-direction: row;
`;

const RoutingServiceBody = styled.div`
  display: flex;
  flex-direction: row;
  //overflow: scroll;
  //height: flex-grow;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // width: 24%;
  // height: 100vh;
  // margin: 0;
  // box-sizing: border-box;
  // overflow: scroll;
`;
